(function () {
  function applyLayout() {
    var header = document.querySelector('.site-header');
    var main = document.querySelector('main');
    if (!header || !main) return;

    var headerHeight = header.offsetHeight;

    main.style.marginTop = headerHeight + 'px';
    main.style.minHeight = 'calc(100vh - ' + headerHeight + 'px)';
  }

  window.addEventListener('load', applyLayout);
  window.addEventListener('resize', applyLayout);
})();
